<template>
  <v-card>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template #activator="{ on }">
        <v-text-field
          :value="displayMonth"
          :label="$t('kpi.text.date')"
          prepend-icon="event"
          readonly
          v-on="on"
        />
      </template>
      <v-date-picker v-model="month" type="month" @input="menu = false" />
    </v-menu>
    <span v-if="downloadedCount">
      {{ downloadedCount }}{{ $t('kpi.text.itemsRetrieved') }}
    </span>
    <v-card-actions>
      <v-spacer />
      <v-btn color="error" :disabled="!downloading" @click="abort = true">
        {{ $t('common.button.abort') }}
      </v-btn>
      <v-btn
        color="primary"
        :disabled="!month"
        :loading="downloading"
        @click="getCSV"
      >
        {{ $t('common.button.export') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { formatMonthForDisplay, formatDateTimeForDisplay } from '@/utils'
import moment from 'moment'
// DATA_PROPS sẽ được tạo trong computed để sử dụng i18n

export default {
  name: 'KPIMonthly',
  data: () => ({
    menu: false,
    month: moment()
      .subtract(1, 'month')
      .format('YYYY-MM'),
    downloading: false,
    abort: false,
    downloadedCount: 0,
  }),
  computed: {
    displayMonth() {
      return formatMonthForDisplay(this.month, this.$i18n.locale) || ''
    },
    dataProps() {
      const t = this.$t.bind(this)
      return [
        {
          text: t('kpi.csv.reservationRegisteredShopCode'),
          prop: 'prevShopCode',
        },
        {
          text: t('kpi.csv.reservationRegisteredShopName'),
          prop: 'prevShopName',
        },
        { text: t('kpi.csv.visitShopCode'), prop: 'shopCode' },
        { text: t('kpi.csv.visitShopName'), prop: 'shopName' },
        { text: t('kpi.csv.visitDate'), prop: 'date' },
        {
          text: t('kpi.csv.reservationRegisteredDateTime'),
          prop: 'registered',
          transform: v => formatDateTimeForDisplay(v, this.$i18n.locale),
        },
        { text: t('kpi.csv.reservationStatus'), prop: 'state' },
        { text: t('kpi.csv.reservationRoute'), prop: 'reservingWay' },
        { text: t('kpi.csv.attendedStaffCode'), prop: 'attendedStaffCode' },
        { text: t('kpi.csv.attendedStaffName'), prop: 'attendedStaffName' },
        { text: t('kpi.csv.previousDyeingStaffCode'), prop: 'dyeingStaffCode' },
        { text: t('kpi.csv.previousDyeingStaffName'), prop: 'dyeingStaffName' },
        ...(this.$i18n.locale === 'ja'
          ? [
              {
                text: t('kpi.csv.reserverFamilyNameKana'),
                prop: 'reserverFamilyNameKana',
              },
              {
                text: t('kpi.csv.reserverGivenNameKana'),
                prop: 'reserverGivenNameKana',
              },
            ]
          : []),
        { text: t('kpi.csv.customerNumber'), prop: 'customerNumber' },
        ...(this.$i18n.locale === 'ja'
          ? [
              {
                text: t('kpi.csv.customerFamilyNameKana'),
                prop: 'customerFamilyNameKana',
              },
              {
                text: t('kpi.csv.customerGivenNameKana'),
                prop: 'customerGivenNameKana',
              },
            ]
          : []),
      ]
    },
  },
  methods: {
    async getCSV() {
      try {
        let month = this.month
        this.downloading = true
        let rows = await this.request([this.dataProps.map(x => x.text)])
        if (this.abort) {
          this.$toast.info(this.$t('toast.message.aborted'))
        } else if (rows.length <= 1) {
          // NOTE: ヘッダで1行は必ずある
          this.$toast.error(this.$t('toast.message.noData'))
        } else {
          this.dl(`kpi-montyly-${month}.csv`, rows)
        }
      } catch (err) {
        console.error(err)
        this.$toast.error(this.$t('toast.message.errorOccurred'))
      }
      this.downloading = false
      this.abort = false
      this.downloadedCount = 0
    },
    async request(r, url = null) {
      let { results, next } = await (url
        ? this.$api.http.get(url)
        : this.$api.kpis.monthly(this.month))
      if (this.abort) return
      results = results.map(data =>
        this.dataProps.map(x => this.transform(data, x))
      )
      r = r.concat(results)
      this.downloadedCount = r.length - 1
      if (next) return await this.request(r, next)
      else return r
    },
    transform(data, { prop, transform }) {
      let rval = data[prop] || ''
      if (transform) {
        rval = transform(rval)
      }
      return `"${rval}"`
    },
    dl(filename, rows) {
      rows = rows.map(row => row.join(','))
      let content = rows.join('\r\n')
      let bom = new Uint8Array([0xef, 0xbb, 0xbf])
      let blob = new Blob([bom, content], { type: 'text/csv' })

      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, filename)
      } else {
        let a = document.createElement('a')
        a.download = filename
        // a.target = '_blank'
        a.href = window.URL.createObjectURL(blob)

        // firefox対策． chromeの場合は append/remove をしなくていいらしい
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }
    },
  },
}
</script>
